
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/story/[id]",
      function () {
        return require("private-next-pages/app/story/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/story/[id]"])
      });
    }
  